import CallToBeauty from "../assets/files/beauty/call_to_beauty.pdf";
import ThoughtsOnBeauty from "../assets/files/beauty/thought_on_beauty.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const BeautyList: EssayType[] = [
  {
    name: "Call to Beauty",
    file: CallToBeauty,
  },
  {
    name: "Thoughts on Beauty",
    file: ThoughtsOnBeauty,
  },
];

export default BeautyList;
export type { EssayType };
